var React = require('react');

function RecycleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M12 1c3.72 0 7.01 1.847 9 4.674V2h2v7h-7V7h3.485A9 9 0 0 0 3 12H1C1 5.925 5.925 1 12 1Zm0 22c-3.72 0-7.01-1.847-9-4.674V22H1v-7h7v2H4.516A9 9 0 0 0 21 12h2c0 6.075-4.925 11-11 11Z","clipRule":"evenodd"}));
}

RecycleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":""};

module.exports = RecycleInline;

RecycleInline.default = RecycleInline;
